import { createSlice } from '@reduxjs/toolkit';

// Slice
export const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    payment: {},
    paymentOptions: {}
  },
  reducers: {
    setPaymentOptionsData: (state, action) => {
      state.paymentOptions[action.payload.name] = action.payload.data;
    },
    setPaymentData: (state, action) => {
      state.payment = action.payload;
    },
  },
});

// Actions
export const { setPaymentOptionsData, setPaymentData } = paymentSlice.actions;

// Selector
export const paymentState = state => state.payment;

// Reducer
export default paymentSlice.reducer;
